<template>
  <span
    :class="`tag top`"
    style="--tag-background: var(--fa-dk-navy); --tag-color: white"
  >
    <span
      v-if="label.sr"
      class="sr-only"
    >
      {{ label.sr }}
    </span>
    {{ label.visible }}
  </span>
</template>

<script>
  import get from 'lodash/get'

  export default {
    name: 'CurrentPlanBadge',

    props: {
      plan: {
        type: Object
      },

      subscription: {
        type: Object
      },

      determinations: {
        type: Object,
        required: true
      },

      colorSet: {
        type: Object,
        required: true
      }
    },

    computed: {
      label() {
        const {
          renewingSoon,
          paymentOnFile,
          withinRenewalGracePeriod,
          cancelAtPeriodEnd,
          paymentFailed,
          updatedPaymentAfterFailure,
          ended,
          preOrderBackerStage
        } = this.determinations

        const plan = this.plan

        let val = {
          sr: 'This is your',
          visible: 'current plan'
        }

        if (!plan && ['alerting', 'grace-period'].indexOf(preOrderBackerStage) > -1) {
          val = {
            visible: 'Services ending'
          }
        }

        if (!plan && ['shutoff'].indexOf(preOrderBackerStage) > -1) {
          val = {
            visible: 'Services expired'
          }
        }

        if (!plan && renewingSoon && !paymentOnFile) {
          val = {
            visible: 'Payment required'
          }
        }

        if (!plan && withinRenewalGracePeriod && cancelAtPeriodEnd) {
          val = {
            visible: 'Renew now'
          }
        }

        if (!plan && !cancelAtPeriodEnd && paymentFailed && !updatedPaymentAfterFailure) {
          val = {
            visible: 'Payment failed'
          }
        }

        if (!plan && ended) {
          val = {
            visible: 'Plan expired'
          }
        }

        // pro.canceled plan
        if (get(plan, ['active']) && ended) {
          val = {
            visible: 'Plan expired'
          }
        }

        return val
      }
    }
  }
</script>
